import { toast } from "sonner";
import { formatCurrency } from "@/config/locale";
import { buildAdShareUrl } from "@/app/utils/ad-share";

/**
 * Same behaviour as Ad Detail "Compartilhar": Web Share API when available, else clipboard + toast.
 * Keep title without bundling into `url` (see buildAdShareUrl / ad-share docs).
 */
export async function shareAdListing(params: {
  adId: string;
  title: string;
  price: number;
}): Promise<void> {
  const url = buildAdShareUrl(params.adId);
  if (!url) {
    toast.error("Não foi possível gerar o link.");
    return;
  }
  const t = params.title?.trim() || "Anúncio akihub";
  const shareTitle = `${t} — ${formatCurrency(params.price)}`;
  try {
    if (typeof navigator !== "undefined" && navigator.share) {
      await navigator.share({ title: shareTitle, url });
      return;
    }
  } catch (e: unknown) {
    if ((e as { name?: string })?.name === "AbortError") return;
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copiado para a área de transferência.");
  } catch {
    toast.error("Não foi possível copiar o link. Copie manualmente: " + url);
  }
}
